enum CalibrationKeys {
  LTM_REVENUE_INPUTS = 'ltm_revenue_inputs',
  NTM_REVENUE_INPUTS = 'ntm_revenue_inputs',
  LTM_EBITDA_INPUTS = 'ltm_ebitda_inputs',
  NTM_EBITDA_INPUTS = 'ntm_ebitda_inputs',
}

export default CalibrationKeys;
